import LocalizedStrings from '../Localization/localization';

// Tutorial 0
import Manual1 from './images/Manual_sencer_EN-1.png';
import Manual2 from './images/Manual_sencer_EN-2.png';
import Manual3 from './images/Manual_sencer_EN-3.png';
import Manual4 from './images/Manual_sencer_EN-4.png';
import Manual5 from './images/Manual_sencer_EN-5.png';
import Manual6 from './images/Manual_sencer_EN-6.png';
import Manual7 from './images/Manual_sencer_EN-7.png';

// Tutorial 1
import Manual8 from './images/Manual_sencer_EN-8.png';
import Manual9 from './images/Manual_sencer_EN-9.png';
import Manual10 from './images/Manual_sencer_EN-10.png';
import Manual11 from './images/Manual_sencer_EN-11.png';
import Manual12 from './images/Manual_sencer_EN-12.png';
import Manual13 from './images/Manual_sencer_EN-13.png';

// Tutorial 2
import Manual14 from './images/Manual_sencer_EN-14.png';
import Manual15 from './images/Manual_sencer_EN-15.png';
import Manual16 from './images/Manual_sencer_EN-16.png';
import Manual17 from './images/Manual_sencer_EN-17.png';
import Manual18 from './images/Manual_sencer_EN-18.png';

// Tutorial 3
import Manual19 from './images/Manual_sencer_EN-19.png';
import Manual20 from './images/Manual_sencer_EN-20.png';

// Tutorial 4
import Manual21 from './images/Manual_sencer_EN-21.png';
import Manual22A from './images/Manual_sencer_EN-22.png';
import Manual22B from './images/Manual_sencer_EN-22b.png';
import Manual23 from './images/Manual_sencer_EN-23.png';
import Manual24 from './images/Manual_sencer_EN-24.png';
import Manual25 from './images/Manual_sencer_EN-25.png';
import Manual26 from './images/Manual_sencer_EN-26.png';
import Manual28 from './images/Manual_sencer_EN-28.png';
import Manual29A from './images/Manual_sencer_EN-29a.png';
import Manual29B from './images/Manual_sencer_EN-29b.png';

// Tutorial 5
import Manual30 from './images/Manual_sencer_EN-30.png';
import Manual31 from './images/Manual_sencer_EN-31.png';
import Manual32 from './images/Manual_sencer_EN-32.png';

// Tutorial 7
import Manual33 from './images/Manual_sencer_EN-33.png';

// Tutorial 6
import Manual34 from './images/Manual_sencer_EN-34.png';

// Tutorial 8
import Manual35 from './images/Manual_sencer_EN-35.png';

// Tutorial 9
import Manual36 from './images/Manual_sencer_EN-36.png';

// Tutorial 10
import Manual27 from './images/Manual_sencer_EN-27.png';

// Tutorial 11
import Manual37 from './images/Manual_sencer_EN-37.png';
import Manual38 from './images/Manual_sencer_EN-38.png';
import Manual39 from './images/Manual_sencer_EN-39.png';

// Tutorial 12
import Manual40 from './images/Manual_sencer_EN-40.png';
import Manual41 from './images/Manual_sencer_EN-41.png';

// Tutorial 13
import Manual42 from './images/Manual_sencer_EN-42.png';
import Manual43 from './images/Manual_sencer_EN-43.png';

export default {
    0: {
        name: {
            default: 'Home overview',
            en: 'Home overview',
            es: 'Página principal',
            de: 'Übersicht Startseite',
            fr: 'Regard sur le menu général',
        },
        color: '#2996ed',
        slides: [
            {
                image: Manual1,
                texts: {
                    default: 'Navigate through the corporate structure.',
                    en: 'Navigate through the corporate structure.',
                    es: 'Navega por la estructura corporativa.',
                    de: 'Durch die Unternehmensstruktur navigieren',
                    fr: 'Naviguer dans la structure.',
                },
            },
            {
                image: Manual2,
                texts: {
                    default: 'Browse through all contents and files by tags.',
                    en: 'Browse through all contents and files by tags.',
                    es: 'Explora a través de todos los contenidos y archivos etiquetados (tags).',
                    de: 'Alle Inhalte und Dateien mit Hilfe von Tags durchsuchen',
                    fr: 'Recherchez dans les contenus et les fichiers grâce aux tags.',
                },
            },
            {
                image: Manual3,
                texts: {
                    default: 'Access User Settings and change within other platforms. Change your password and language settings.',
                    en: 'Access User Settings and change within other platforms. Change your password and language settings.',
                    es: 'Accede a la configuración de usuario para cambiar entre plataformas. Cambia tu contraseña y ajustes de idioma.',
                    de:
                        'Zugriff auf User-Einstellungen und Wechsel innerhalb anderer Plattformen. Ändern Sie Ihr Passwort und Ihre Spracheinstellungen.',
                    fr:
                        'Accéder au module de réglage utilisateur et changer de plateformes. Changer le mot de passe et le paramètre de langue.',
                },
            },
            {
                image: Manual4,
                texts: {
                    default: 'Create you own Meetings & showcases.',
                    en: 'Create you own Meetings & showcases.',
                    es: 'Crea tus Meetings y colecciones personalizadas.',
                    de: 'Erstellen Sie Ihre eigenen Meetings und Showcases',
                    fr: 'Créer vos propres rendez-vous (meetings) et vos présentations.',
                },
            },
            {
                image: Manual5,
                texts: {
                    default: 'Stay tuned with Notifications.',
                    en: 'Stay tuned with Notifications.',
                    es: 'Manténte conectado mediante notificaciones.',
                    de: 'Bleiben Sie mit den Benachrichtigungen auf dem Laufenden.',
                    fr: 'Rester informé en temps réel grâce aux notifications.',
                },
            },
            {
                image: Manual6,
                texts: {
                    default: 'Tag your Favorite pages and documents as quicklinks.',
                    en: 'Tag your Favorite pages and documents as quicklinks.',
                    es: 'Marca tus páginas y documentos favoritos como enlaces rápidos.',
                    de: 'Markieren Sie Ihre Seiten- und Dokument-Favoriten als Quicklinks.',
                    fr: 'Tagger vos pages et documents favoris pour gagner du temps.',
                },
            },
            {
                image: Manual7,
                texts: {
                    default: 'Access Editor tools: edit, library, publish contents...',
                    en: 'Access Editor tools: edit, library, publish contents...',
                    es: 'Accede a las herramientas de Editor: editor, biblioteca, publicación de contenidos...',
                    de: 'Zugriff auf Editor-Tools wie Bearbeiten, Bibliothek, Inhalte veröffentlichen,…',
                    fr: "Accéder aux outils d'édition pour éditer, ranger, publier des contenus...",
                },
            },
        ],
    },
    1: {
        name: {
            default: 'Meetings creation process',
            en: 'Meetings creation process',
            es: 'Creación de Meetings',
            de: 'Prozess zur Erstellung von Meetings',
            fr: 'Process de création de rendez-vous (Meetings)',
        },
        color: '#f2423b',
        slides: [
            {
                image: Manual8,
                texts: {
                    default: 'Create your own personalized presentations for specific meetings with own and corporate existing content.',
                    en: 'Create your own personalized presentations for specific meetings with own and corporate existing content.',
                    es:
                        'Crea tus presentaciones personalizadas para reuniones específicas a partir de contenido propio o de material corporativo existente.',
                    de:
                        'Erstellen Sie Ihre eigenen personalisierten Präsentationen für bestimmte Meetings mit eigenen und vorhandenen Inhalten.',
                    fr:
                        "Créer vos présentations personnalisées pour des rendez-vous spécifiques grâce à l'ensemble des documents mis à votre disposition.",
                },
            },
            {
                image: Manual9,
                texts: {
                    default: 'Give the Meeting a name. Define a date & add a preview cover image form the library.',
                    en: 'Give the Meeting a name. Define a date & add a preview cover image form the library.',
                    es: 'Pon un nombre a tu Meeting. Define una fecha y añade una imagen de la biblioteca como vista previa de la portada.',
                    de: 'Geben Sie dem Meeting einen Namen. Legen Sie ein Datum fest und fügen ein Vorschaubild aus der Bibliothek hinzu. ',
                    fr:
                        "Donner un nom à votre rendez-vous (Meeting) , définir une date et choisir une couverture visuelle disponible dans la bibliothèque d'images.",
                },
            },
            {
                image: Manual10,
                texts: {
                    default:
                        'There are two ways of creating a Meeting: From an existing collection or from scratch (Create a new collection).',
                    en: 'There are two ways of creating a Meeting: From an existing collection or from scratch (Create a new collection).',
                    es: 'Hay dos formas de crear un Meeting: a partir de una colección existente o desde cero (crear una nueva colección).',
                    de:
                        'Es gibt zwei Möglichkeiten ein Meeting anzulegen: aus einer bestehenden Collection oder einer neuen (neue Collection erstellen)',
                    fr:
                        'Il y a deux façons pour créer un rendez-vous (Meeting): depuis une collection existante ou en partant de zéro (Créer une nouvelle collection).',
                },
            },
            {
                image: Manual11,
                texts: {
                    default: 'Select from existing contents (either from a collection, from the structure or library items).',
                    en: 'Select from existing contents (either from a collection, from the structure or library items).',
                    es:
                        'Selecciona entre los contenidos existentes (ya sean de una colección, de la estructura o elementos de la biblioteca).',
                    de:
                        'Wählen Sie aus bestehendem Inhalt aus (entweder aus einer Collection, aus der Struktur oder Inhalten aus der Bibliothek).',
                    fr: 'Sélectionner des contenus existants (soit depuis une collection, ou depuis la bibliothèque).',
                },
            },
            {
                image: Manual12,
                texts: {
                    default: 'Review Summary and tap on Create.',
                    en: 'Review Summary and tap on Create.',
                    es: 'Revisa el sumario y clica en Create.',
                    de: 'Zusammenfassung überprüfen und auf "Erstellen" klicken.',
                    fr: 'Passer en revue les données disponibles et créer.',
                },
            },
            {
                image: Manual13,
                texts: {
                    default:
                        'Contents will be displayed automatically. Edit the final layout or add more contents. Add your comments and attach your meeting notes under the Feedback section.',
                    en:
                        'Contents will be displayed automatically. Edit the final layout or add more contents. Add your comments and attach your meeting notes under the Feedback section.',
                    es:
                        'Los contenidos se mostrarán automáticamente. Edita el diseño final o añade más contenidos. Agrega comentarios y adjunta tus notas de la reunión en la sección Comentarios.',
                    de:
                        'Inhalte werden automatisch angezeigt. Bearbeiten Sie das finale Layout oder fügen neue Inhalte hinzu. Kommentieren Sie und fügen Ihre Meeting-Notizen im Feeback-Bereich hinzu.',
                    fr:
                        'Les contenus sont diffusés automatiquement. Editez la présentation finale ou ajoutez de nouveaux contenus. Intégrez vos commentaires et joindre vos commentaires et notes.',
                },
            },
        ],
    },
    2: {
        name: {
            default: 'Collections creation process',
            en: 'Collections creation process',
            es: 'Creación de Collections',
            de: 'Prozess zur Erstellung von Collections',
            fr: 'Process de création des Collections',
        },
        color: '#f2423b',
        slides: [
            {
                image: Manual14,
                texts: {
                    default: 'Create your own personalised presentations with existing corporate content to have easy access.',
                    en: 'Create your own personalised presentations with existing corporate content to have easy access.',
                    es:
                        'Crea tus propias presentaciones personalizadas con contenido corporativo existente para acceder a ellas fácilmente.',
                    de: 'Erstellen Sie Ihre individuellen Präsentationen mit bestehenden Inhalten.',
                    fr: 'Créez vos propres présentations personnalisées grâce à tous les documents mis à votre disposition.',
                },
            },
            {
                image: Manual15,
                texts: {
                    default: 'Enter a Collection name and select a Language. Add a preview cover image form the library to be displayed.',
                    en: 'Enter a Collection name and select a Language. Add a preview cover image form the library to be displayed.',
                    es:
                        'Dale un nombre a tu colección y selecciona un idioma. Añade una imagen de la biblioteca que se mostrará como vista previa de la portada.',
                    de:
                        'Geben Sie der Collection einen Namen und wählen die Sprache. Fügen Sie ein Vorschaubild aus der Bibliothek hinzu. ',
                    fr:
                        "Créez un nom pour votre collection et sélectionnez un langage, une couverture visuelle spécifique en partant de la bibliothèque d'images.",
                },
            },
            {
                image: Manual16,
                texts: {
                    default: 'Select resources from the existing contents structure or search directly from the library.',
                    en: 'Select resources from the existing contents structure or search directly from the library.',
                    es: 'Selecciona recursos entre los contenidos existentes de la estructura o busca directamente desde la biblioteca.',
                    de: 'Wählen Sie aus bestehendem Inhalt aus der Struktur aus oder suchen Sie nach Inhalten aus der Bibliothek.',
                    fr: 'Sélectionnez des ressources depuis les contenus existants ou recherchez directement dans la bibliothèque.',
                },
            },
            {
                image: Manual17,
                texts: {
                    default: 'Review the summary and tap on Create.',
                    en: 'Review the summary and tap on Create.',
                    es: 'Revisa el sumario y clica en Create.',
                    de: 'Zusammenfassung überprüfen und auf "Erstellen" klicken.',
                    fr: 'Passez en revue les données disponibles et Créer.',
                },
            },
            {
                image: Manual18,
                texts: {
                    default:
                        'Contents will be displayed automatically. Edit the final layout or add more contents. <em><strong>Collections can always become meetings by assigning them a date.</strong></em>',
                    en:
                        'Contents will be displayed automatically. Edit the final layout or add more contents. <em><strong>Collections can always become meetings by assigning them a date.</strong></em>',
                    es:
                        'Los contenidos se mostrarán automáticamente. Edita el diseño final o añade más contenidos. <em><strong>Convierte tus colecciones en Meetings asignándoles una fecha.</strong></em>',
                    de:
                        'Inhalte werden automatisch angezeigt. Bearbeiten Sie das finale Layout oder fügen neue Inhalte hinzu. <em><strong>Collections können durch das Hinzufügen eines Datums zu Meetings umgewandelt werden.</strong></em>',
                    fr:
                        'Les contenus peuvent être mis à disposition automatiquement. Editez la présentation finale ou ajoutez de nouveaux contenus. <em><strong>les Collections peuvent être utilisées et transformées en rendez-vous (meetings) en leur assignant une date.</strong></em>',
                },
            },
        ],
    },
    3: {
        name: {
            default: LocalizedStrings.favorites,
            en: LocalizedStrings.favorites,
            es: LocalizedStrings.favorites,
            de: LocalizedStrings.favorites,
            fr: LocalizedStrings.favorites,
        },
        color: '#fcbf2e',
        slides: [
            {
                image: Manual19,
                texts: {
                    default: 'Create your own quicklinks for the most used contents when navigating through the content structure.',
                    en: 'Create your own quicklinks for the most used contents when navigating through the content structure.',
                    es:
                        'Crea tus propios enlaces rápidos para los contenidos que más utilizas al navegar a través del contenido de la estructura.',
                    de:
                        'Erstellen Sie Ihre eigenen Quicklinks für die meistgenutzten Inhalte während der Navigation durch die Inhaltsstruktur. ',
                    fr: 'Créez vos propres accès rapides en fonction de vos contenus les plus utilisés.',
                },
            },
            {
                image: Manual20,
                texts: {
                    default: 'Tap on the Star icon to mark as favorites. You can either mark structure or pages.',
                    en: 'Tap on the Star icon to mark as favorites. You can either mark structure or pages.',
                    es:
                        'Toca el icono de la estrella para marcar como Favorito. Puedes marcar tanto material de la estructura como de las páginas.',
                    de:
                        'Klicken Sie auf das Stern-Symbol, um Inhalte als Favoriten zu markieren. Sie können die Struktur oder Seiten dafür markieren. ',
                    fr: "Cliquez sur l'icône Etoile pour désigner vos favoris. Vous pouvez sélectionner des pages ou des fichiers.",
                },
            },
        ],
    },
    10: {
        name: {
            default: 'Backend Tools',
            en: 'Backend Tools',
            es: 'Herramientas de Backend',
            de: 'Backend-Tools',
            fr: 'Outils de backend',
        },
        color: '#33a854',
        slides: [
            {
                image: Manual27,
                texts: {
                    default: 'Access all the editor tools from one single source.',
                    en: 'Access all the editor tools from one single source.',
                    es: 'Accede a todas las herramientas de edición desde aquí.',
                    de: 'Greifen Sie auf alle Editor-Tools von einer Stelle aus zu.',
                    fr: "Aller dans les outils d'édition.",
                },
            },
        ],
    },
    4: {
        name: {
            default: 'Content Editor',
            en: 'Content Editor',
            es: 'Editor de Contenidos',
            de: 'Content-Editor',
            fr: 'Éditeur de contenu',
        },
        color: '#33a854',
        slides: [
            {
                image: Manual21,
                texts: {
                    default: 'Manage page settings and layout, name, languages and visibility.',
                    en: 'Manage page settings and layout, name, languages and visibility.',
                    es: 'Gestiona la configuración de la página y el diseño, nombre, idiomas y visibilidad.',
                    de: 'Bearbeiten Sie Seiteneinstellungen, Layout, Name, Sprache und Sichtbarkeit.',
                    fr: 'Gérer les réglages de la page et la présentation, le nom, le langage et son visuel.',
                },
            },
            {
                image: Manual28,
                texts: {
                    default: 'Manage page settings and layout, name, languages and visibility.',
                    en: 'Manage page settings and layout, name, languages and visibility.',
                    es: 'Gestiona la configuración de la página y el diseño, nombre, idiomas y visibilidad.',
                    de: 'Bearbeiten Sie Seiteneinstellungen, Layout, Name, Sprache und Sichtbarkeit.',
                    fr: 'Gérez les paramètres et la mise en page, le nom, les langues et la visibilité de la page.',
                },
            },
            {
                image: Manual29B,
                texts: {
                    default: 'In categories manage page settings and layout',
                    en: 'In categories manage page settings and layout',
                    es: 'En una categoría gestiona la configuración de la página y el diseño',
                    de: 'Seiteneinstellungen und Layout in Kategorien verwalten.',
                    fr: 'Dans les categories vous pouvez gérer les réglages de la page et la présentation',
                },
            },
            {
                image: Manual29A,
                texts: {
                    default:
                        'In metadocuments drag and drop the basic, structure or custom sections to the page and create your own layouts.',
                    en: 'In metadocuments drag and drop the basic, structure or custom sections to the page and create your own layouts.',
                    es:
                        'En un metadocumento arrastra las secciones básicas, de la estructura o personalizadas, a la página y crea tus propios diseños.',
                    de:
                        'Ziehen Sie in Metadokumenten die Basis-, Struktur- oder benutzerdefinierten Abschnitte per Drag & Drop auf die Seite und erstellen Sie Ihre eigenen Layouts.',
                    fr:
                        "Grâce à la fonction permettant de glisser d'un point à un autre les metadocuments, vous pouvez personnaliser votre page et créer votre propre présentation.",
                },
            },
            {
                image: Manual22A,
                texts: {
                    default:
                        'In categories, structure and contents are displayed as the final result. Arrange, move, copy or link categories in the content structure.',
                    en:
                        'In categories, structure and contents are displayed as the final result. Arrange, move, copy or link categories in the content structure.',
                    es:
                        'En una categoría, la estructura y los contenidos se muestran como el resultado final. Organiza, mueve, copia o vincula categorías dentro de la estructura de contenido.',
                    de:
                        'Struktur und Inhalte werden Ihnen bei den Kategorien als finales Ergebnis angezeigt. Sie können in der Inhaltsstruktur anordnen, verschieben, kopieren oder verlinken.',
                    fr:
                        'Dans les categories, la structure et les contenus sont présentés dans une vision définitive. Vous pouvez déplacer, copier ou lier les catégories dans la structure des contenus',
                },
            },
            {
                image: Manual22B,
                texts: {
                    default:
                        'In metadocuments, structure and contents are displayed as the final result. Move or copy sections in the content structure.',
                    en:
                        'In metadocuments, structure and contents are displayed as the final result. Move or copy sections in the content structure.',
                    es:
                        'En un metadocumento, la estructura y los contenidos se muestran como el resultado final. Mueve o copia secciones dentro de la estructura.',
                    de:
                        'Ziehen Sie in Metadokumenten die Basis-, Struktur- oder benutzerdefinierten Abschnitte per Drag & Drop auf die Seite und erstellen Sie Ihre eigenen Layouts.',
                    fr:
                        'Au sein des Metadocuments, la structure et les contenus sont présentés dans une vision définitive. Vous pouvez déplacer ou coper des sections dans la structure de contenus',
                },
            },
            {
                image: Manual23,
                texts: {
                    default: 'Preview changes, change language and publish.',
                    en: 'Preview changes, change language and publish.',
                    es: 'Previsualiza los cambios, cambia el idioma y publica.',
                    de: 'Vorschau der Änderungen, Sprache ändern und veröffentlichen.',
                    fr: 'Prévisualisez vos modifications,  changer de langue et publier.',
                },
            },
            {
                image: Manual24,
                texts: {
                    default: 'Preview to see how does it look on the online version.',
                    en: 'Preview to see how does it look on the online version.',
                    es: 'Previsualiza para ver cómo se va a mostrar en la versión online.',
                    de: 'Vorschau der Online-Version',
                    fr: "Prévisualiser pour voir l'aperçu dans sa version en ligne.",
                },
            },
            {
                image: Manual25,
                texts: {
                    default: 'Change language (if available).',
                    en: 'Change language (if available).',
                    es: 'Cambia el idioma (si está disponible).',
                    de: 'Sprache ändern (sofern verfügbar)',
                    fr: 'Changer de langue (si disponible).',
                },
            },
            {
                image: Manual26,
                texts: {
                    default: 'Directly publish the page you are working on.',
                    en: 'Directly publish the page you are working on.',
                    es: 'Publica directamente la página en la que estás trabajando.',
                    de: 'Direkte Veröffentlichung der derzeit bearbeiteten Seite.',
                    fr: 'publier directement la page sur laquelle vous travaillez',
                },
            },
        ],
    },
    5: {
        name: {
            default: LocalizedStrings.library,
            en: LocalizedStrings.library,
            es: LocalizedStrings.library,
            de: LocalizedStrings.library,
            fr: LocalizedStrings.library,
        },
        color: '#33a854',
        slides: [
            {
                image: Manual30,
                texts: {
                    default: 'Upload either massive or individual documents to the PDC library. Tag documents and apply visibility.',
                    en: 'Upload either massive or individual documents to the PDC library. Tag documents and apply visibility.',
                    es:
                        'Carga nuevos documentos a la biblioteca de PDC, ya sea de forma masiva o invidualmente. Etiqueta los documentos y aplica la visibilidad.',
                    de:
                        'Massen- oder Einzel-Upload in die Bibliothek. Versehen Sie Ihre Dokumente mit Tags und wählen Sie die Sichtbarkeit aus.',
                    fr:
                        'Charger des documents soit en masse ou individuellement dans la bibliothèque. Tagger des documents et donner la visibilité.',
                },
            },
            {
                image: Manual31,
                texts: {
                    default: 'Search files by tags, by visibility or by editors and edit them individually or in groups.',
                    en: 'Search files by tags, by visibility or by editors and edit them individually or in groups.',
                    es: 'Busca archivos por etiquetas (tags), por visibilidad o por editores, y edítalos individualmente o en grupos.',
                    de:
                        'Suchen Sie Dateien per Tags, per Sichtbarkeit oder per Editor und bearbeiten Sie diese individuell oder in Gruppen.',
                    fr: 'Rechercher des fichiers par tags, par visibilité ou par éditeurs et les éditer individuellement ou en groupes.',
                },
            },
            {
                image: Manual32,
                texts: {
                    default:
                        'Edit files individually by making them shareable or editing tags. Update file by uploading a new one and keep all files properties.',
                    en:
                        'Edit files individually by making them shareable or editing tags. Update file by uploading a new one and keep all files properties.',
                    es:
                        'Edita archivos individualmente haciéndolos compartibles (shareable) o edita sus tags. Actualiza el archivo cargando uno nuevo que mantendrá todas las propiedades.',
                    de:
                        'Bearbeiten Sie Dateien individuell, indem Sie diese teilbar machen oder die Tags bearbeiten. Aktualisieren Sie Ihre Datei, indem sie eine neue hochladen und alle Datei-Eigenschaften beibehalten. ',
                    fr:
                        'Editer des fichiers individuellement et partager ou éditer des tags. Charger un nouveau fichier en gardant ses propriétés.',
                },
            },
        ],
    },
    6: {
        name: {
            default: LocalizedStrings.users,
            en: LocalizedStrings.users,
            es: LocalizedStrings.users,
            de: LocalizedStrings.users,
            fr: LocalizedStrings.users,
        },
        color: '#33a854',
        slides: [
            {
                image: Manual34,
                texts: {
                    default: 'Manage users and groups: invite, delete and assign them to user groups. Give them editor or admin rights.',
                    en: 'Manage users and groups: invite, delete and assign them to user groups. Give them editor or admin rights.',
                    es:
                        'Gestiona usuarios y grupos de usuarios: invita, borra y asigna Usergroups. Puedes dar a un usuario derechos de Editor o de Administrador.',
                    de:
                        'User und Gruppen verwalten: User einladen, löschen und die User-Gruppen zuordnen. Usern Editor- oder Adminrechte zuordnen. ',
                    fr:
                        "Gérer les utilisateurs et les groupes: inviter, supprimer et assigner des utilisateurs dans un groupe. Donner un accès d'administrateur ou d'éditeur.",
                },
            },
        ],
    },
    7: {
        name: {
            default: LocalizedStrings.notifications,
            en: LocalizedStrings.notifications,
            es: LocalizedStrings.notifications,
            de: LocalizedStrings.notifications,
            fr: LocalizedStrings.notifications,
        },
        color: '#33a854',
        slides: [
            {
                image: Manual33,
                texts: {
                    default: 'Create and send notifications to target user groups. You can also resend already created notifications.',
                    en: 'Create and send notifications to target user groups. You can also resend already created notifications.',
                    es: 'Crea y envía notificaciones a grupos de usuarios. También puedes reenviar notificaciones ya creadas.',
                    de:
                        'Erstellen und verschicken Sie Benachrichtigungen an Ziel-User-Gruppen. Sie können auch bereits gesendete Benachrichtigungen noch einmal versenden.',
                    fr: 'Créer et adresser des notifications à des groupes ciblés. Vous pouvez également réactiver des notifications.',
                },
            },
        ],
    },
    8: {
        name: {
            default: LocalizedStrings.shares,
            en: LocalizedStrings.shares,
            es: LocalizedStrings.shares,
            de: LocalizedStrings.shares,
            fr: LocalizedStrings.shares,
        },
        color: '#33a854',
        slides: [
            {
                image: Manual35,
                texts: {
                    default: 'Trace what your users are sharing, when and to whom.',
                    en: 'Trace what your users are sharing, when and to whom.',
                    es: 'Controla todo lo que comparten los usuarios, cuándo y con quién.',
                    de: 'Nachverfolgen, was Ihre User wann und für wen freigeben.',
                    fr: 'Suivre ce que les utilisateurs partagent, quand et à qui',
                },
            },
        ],
    },
    9: {
        name: {
            default: LocalizedStrings.publish,
            en: LocalizedStrings.publish,
            es: LocalizedStrings.publish,
            de: LocalizedStrings.publish,
            fr: LocalizedStrings.publish,
        },
        color: '#33a854',
        slides: [
            {
                image: Manual36,
                texts: {
                    default: 'Publish all pending content or select specific.',
                    en: 'Publish all pending content or select specific.',
                    es: 'Publica todo el contenido pendiente o escoge lo que quieres publicar específicamente.',
                    de: 'Alle ausstehenden Inhalte veröffentlichen oder bestimmte auswählen.',
                    fr: 'Publier les contenus en attente ou sélectionner des contenus spécifiques.',
                },
            },
        ],
    },
    11: {
        name: {
            default: 'User Settings',
            en: 'User Settings',
            es: 'Ajustes de Usuario',
            de: 'Benutzereinstellungen',
            fr: 'Paramètres utilisateur',
        },
        color: '#2996ed',
        slides: [
            {
                image: Manual37,
                texts: {
                    default: 'Change within the platforms you have access to.',
                    en: 'Change within the platforms you have access to.',
                    es: 'Salta entre las plataformas a las que tienes acceso.',
                    de: 'Wechsel zwischen Länderversionen, zu denen Sie Zugang haben.',
                    fr: 'Changer de plateforme.',
                },
            },
            {
                image: Manual38,
                texts: {
                    default: 'Change the language of the platform.',
                    en: 'Change the language of the platform.',
                    es: 'Cambia el idioma de la plataforma.',
                    de: 'Ändern der Sprache der Plattform.',
                    fr: 'Changer la langue de la plateforme.',
                },
            },
            {
                image: Manual39,
                texts: {
                    default: 'Change your password.',
                    en: 'Change your password.',
                    es: 'Cambia tu contraseña.',
                    de: 'Ändern Sie hier Ihr Passwort.',
                    fr: 'Changer de mot de passe.',
                },
            },
        ],
    },
    12: {
        name: {
            default: 'Download App',
            en: 'Download App',
            es: 'Descarga la App',
            de: 'App-Download',
            fr: "Télécharger l'App",
        },
        color: '#2996ed',
        slides: [
            {
                image: Manual40,
                texts: {
                    default: 'Download and install the app on your device (if available for your device type).',
                    en: 'Download and install the app on your device (if available for your device type).',
                    es: 'Descarga e instala la app en tu dispositivo (si está disponible para tu tipo de dispositivo).',
                    de: 'Download und Einrichtung der App auf Ihrem Gerät (sofern für Ihren Gerätetyp verfügbar).',
                    fr: "Télécharger et installer l'app sur votre matériel (si disponible pour votre type de matériel).",
                },
            },
        ],
    },
    13: {
        name: {
            default: 'Download App',
            en: 'Download App',
            es: 'Descarga la App',
            de: 'App-Download',
            fr: "Télécharger l'App",
        },
        color: '#2996ed',
        slides: [
            {
                image: Manual41,
                texts: {
                    default: 'Download and install the app on your device (if available for your device type).',
                    en: 'Download and install the app on your device (if available for your device type).',
                    es: 'Descarga e instala la app en tu dispositivo (si está disponible para tu tipo de dispositivo).',
                    de: 'Download und Einrichtung der App auf Ihrem Gerät (sofern für Ihren Gerätetyp verfügbar).',
                    fr: "Télécharger et installer l'App sur votre matériel (si disponible pour votre matériel).",
                },
            },
        ],
    },
    14: {
        name: {
            default: 'Share Content',
            en: 'Share Content',
            es: 'Comparte Contenido',
            de: 'Inhalte teilen',
            fr: 'Partager du contenu',
        },
        color: '#2996ed',
        slides: [
            {
                image: Manual42,
                texts: {
                    default: 'Click the icon to share the selected content.',
                    en: 'Click the icon to share the selected content.',
                    es: 'Clica en el icono para compartir el contenido seleccionado.',
                    de: 'Klicken Sie auf das Symbol, um den ausgewählten Inhalt zu teilen. ',
                    fr: "Cliquez sur l'icône pour partager les contenus sélectionnés.",
                },
            },
            {
                image: Manual43,
                texts: {
                    default: 'Fill the fields and share all the content you selected in the attachments section.',
                    en: 'Fill the fields and share all the content you selected in the attachments section.',
                    es: 'Completa los datos y comparte todo el contenido que has seleccionado en la sección de adjuntos.',
                    de: 'Füllen Sie die Felder aus und geben Sie alle Inhalte frei, die Sie im Abschnitt "Anhänge" ausgewählt haben.',
                    fr: 'Complétez les champs et partagea tous les documents que vous avez sélectionné dans la section pièces jointes.',
                },
            },
        ],
    },
};
